import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ConfirmCancelUploadDialog } from '../ConfirmCancelUploadDialog';
import { FilesPreview } from '../FilesPreview';
import { useUpload } from '../UploadProvider';
import { UploadingState } from '../UploadingState';
export function UploadDialog(props) {
    const { subtitle } = props;
    const { isUploading, isUploadDisabled, closeDialog, startUpload, renderConfirmCancelDialog } = useUpload();
    const handleClose = () => closeDialog();
    return (<Fragment>
      {renderConfirmCancelDialog && <ConfirmCancelUploadDialog />}
      <Dialog onClose={handleClose}>
        <DialogHeader icon={<Falcon icon="file-upload"/>} title={t({
            message: 'Upload documents',
            comment: 'Upload documents dialog - Header title',
        })} subtitle={subtitle} action={<IconButton $round size="small" appearance="ghost" onClick={handleClose}>
              <Falcon icon="xmark"/>
            </IconButton>}/>
        <DialogContent>{isUploading ? <UploadingState /> : <FilesPreview />}</DialogContent>
        <DialogFooter>
          <Button size="small" type="button" appearance={isUploading ? 'danger' : 'secondary'} onClick={handleClose}>
            <Trans comment="Upload documents dialog - Cancel button label">Cancel</Trans>
          </Button>
          {!isUploading && (<Button size="small" type="button" disabled={isUploadDisabled} onClick={startUpload}>
              <Trans comment="Upload documents dialog - Start upload button label">Upload</Trans>
            </Button>)}
        </DialogFooter>
      </Dialog>
    </Fragment>);
}
